import MultilineText from './src/MultilineText';

/* istanbul ignore next */
MultilineText.install = function(Vue) {
  Vue.component(MultilineText.name, MultilineText);
};

export default MultilineText;
